import { Switch, Route } from 'react-router-dom';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';

import List from './List';
import Form from './Form';
import Preview from './Preview';

const Roles = ({ match, history }) => (
  <DataGridStateContextProvider>
    <Switch>
      <Route
        exact={true}
        path={`${match.url}/`}
        render={() => <List history={history} />}
      />
      <Route
        path={`${match.url}/add`}
        render={() => <Form history={history} />}
      />
      <Route path={`${match.url}/preview/:id`} component={Preview} />
      <Route
        path={`${match.url}/edit/:id`}
        render={() => <Form isEdit={true} history={history} />}
      />
    </Switch>
  </DataGridStateContextProvider>
);

export default Roles;
